<script setup>
import { useI18n } from 'vue-i18n';

const { tm } = useI18n();

</script>
<template>
  <div class="preview-talk__block">
    <div class="block__con">
      <div class="block__desc">
        <p
          v-for="(text, index) in tm('preview.brandMessageInfo')"
          :key="`preview-brandMessageInfo-${index}`"
          class="block__desc-txt"
        >
          {{ text }}
        </p>
      </div>
      <div class="block__arrow"></div>
    </div>
  </div>
</template>
